import { sendItemInfoSubscribeClickedAnalytic } from '../analytics/sendItemInfoSubscribeClickedAnalytic.ts';
import { uiManagerEvents } from '../EntryShared.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export function getItemInfoSubscribeAction(isItemLocked, itemName, itemType) {
    const shouldShowSubscribe = isItemLocked && !UIUtilsEjsVariables.shouldHideStoreOnMobile;
    if (!shouldShowSubscribe) return undefined;
    return ()=>{
        uiManagerEvents.premiumMembershipCheckAction();
        sendItemInfoSubscribeClickedAnalytic(itemName, itemType);
    };
}
